import React from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import AccountSidebar from '../components/AccountSidebar/AccountSidebar'
import OrdersContainer from '../components/OrdersContainer/OrdersContainer'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import PageHeader from '../components/PageHeader/PageHeader'

function Orders() {
  return (
    <>
    <NavbarContainer/>
    {/* <PageHeader title={'Orders'} /> */}

    <Container>
      <Row>
        <Col md={3}>
        <AccountSidebar/>

        </Col>
        <Col md={9}>
<OrdersContainer/>
        </Col>
      </Row>
    </Container>
    <Footer/>
    </>
  )
}

export default Orders